import { CSSProperties, FC, useCallback, useRef, useState } from 'react'

type Props = {
  children: React.ReactNode
}

const DoubleScrollbar: FC<Props> = props => {
  const [width, setWidth] = useState('auto')
  const outerDivRef = useRef<HTMLDivElement>(null)
  const innerDivRef = useRef<HTMLDivElement>(null)
  const childWrapperRef = useRef<HTMLDivElement>(null)

  const outerDivStyle: CSSProperties = { overflowX: 'auto', overflowY: 'hidden' }
  const innerDivStyle: CSSProperties = { paddingTop: '1px', height: '0px', width }
  const childDivStyle: CSSProperties = { overflowX: 'auto', overflowY: 'hidden' }

  const getChildWrapperWidth = useCallback(() => {
    let newWidth: string | null = null
    if (childWrapperRef.current && childWrapperRef.current.scrollWidth) {
      newWidth = childWrapperRef.current.scrollWidth + 'px'
    }

    return newWidth
  }, [])

  const calculateWidth = useCallback(() => {
    let newWidth = getChildWrapperWidth()

    if (newWidth == null) {
      newWidth = 'auto'
    }

    // Set the width of the inner div to the first child's
    if (newWidth !== width) {
      setWidth(newWidth)
    }
  }, [getChildWrapperWidth, width, setWidth])

  const resizeObserver = new ResizeObserver(() => {
    const outerDiv = outerDivRef.current
    const childWrapper = childWrapperRef.current
    if (!outerDiv || !childWrapper) return

    calculateWidth()

    outerDiv.onscroll = function () {
      if (!childWrapper || !outerDiv) return
      childWrapper.scrollLeft = outerDiv.scrollLeft
    }

    childWrapper.onscroll = function () {
      if (!childWrapper || !outerDiv) return
      outerDiv.scrollLeft = childWrapper.scrollLeft
    }
  })

  if (childWrapperRef.current) {
    resizeObserver.observe(childWrapperRef.current)
  }

  return (
    <div>
      <div ref={outerDivRef} style={outerDivStyle}>
        <div ref={innerDivRef} style={innerDivStyle}>
          &nbsp;
        </div>
      </div>
      <div ref={childWrapperRef} style={childDivStyle}>
        {props.children}
      </div>
    </div>
  )
}

export default DoubleScrollbar
